import { register } from '@shopify/theme-sections'
import $ from 'jquery'
import '../../styles/sections/index-counter.scss'

$.fn.isOnScreen = function(){
  if($(`#counter`).length){
    let win = $(window)
    let viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    }
    viewport.right = viewport.left + win.width()
    viewport.bottom = viewport.top + win.height()

    let bounds = this.offset()
    bounds.right = bounds.left + this.outerWidth()
    bounds.bottom = bounds.top + this.outerHeight()
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom))
  }
}

export default register(`index-counter`, {
  onLoad() {
    let completed = false

    $(document).ready(() =>{
      if($(window).width() > 759) {
        $(window).scroll(() =>{
          if ($(`#counter`).isOnScreen()) {
            $(`.counter-count`).each(function () {

              if(completed != true) {
                $(this).prop(`Counter`,0).animate({
                  Counter: $(this).text()
                 }, {
                  duration: 10000,
                  easing: `swing`,
                  step: function (now) {
                    $(this).text(Math.ceil(now))
                    completed = true
                  }
                })
              }
            })
          }
        })
      } else {
        $(`.body-wrapper`).scroll(() =>{
          if ($(`#counter`).isOnScreen()) {
            $(`.counter-count`).each(function () {
                if(completed != true) {
                  $(this).prop(`Counter`,0).animate({
                    Counter: $(this).text()
                  }, {
                    duration: 10000,
                    easing: `swing`,
                    step: function (now) {
                      $(this).text(Math.ceil(now))
                      completed = true
                    }
                  })
                }
            })
          }
      })
      }
    })

  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

